module.exports = __webpack_public_path__ + "assets/images/EUR5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR5.png
// module id = 1368
// module chunks = 1